import { TradeSettingsPresetForm } from '@root/widgets/trade/trade-settings/desktop'

import type React from 'react'

export const InstantTradeSettings: React.FC = () => <TradeSettingsPresetForm />
